import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';

const PricacyPolicy = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>Kebijakan Privasi</h2>
            <p><strong>Kebijakan Privasi Dreamehome</strong></p>
            <p><strong>Pengantar</strong></p>
            <p>Bisnis “Dreamehome” dioperasikan oleh Dreame Innovation Technology (Suzhou) Co., Ltd. dan perusahaan afiliasinya
                (selanjutnya disebut sebagai “Kami” atau “Dreame”) untuk menyediakan Anda platform (atau layanan) untuk
                mengkontrol
                dan mengelola perangkat pintar. Kami memahami bahwa keamanan data pribadi Anda penting, dan kami akan melakukan
                yang
                terbaik untuk melindungi informasi pribadi Anda. Kami akan menerapkan sejumlah langkah keamanan untuk membantu
                melindungi informasi pribadi Anda sesuai dengan standar industri yang diterima secara umum.</p>
            <p>Oleh karena itu, sebelum Anda menggunakan produk (atau layanan) kami, silahkan membaca dengan seksama dan
                memahami
                Kebijakan Privasi Dreamehome ini. </p>
            <p>Jika Anda masih di bawah umur, silakan menggunakan aplikasi ini dengan persetujuan wali Anda dan menyetujui
                persyaratan layanan aplikasi yang relevan. </p>
            <p>Kebijakan Privasi ini dirancang dengan sepenuhnya mempertimbangkan kepentingan Anda, dan sangat penting bagi Anda
                untuk memahami praktik pengumpulan dan penggunaan informasi pribadi oleh kami secara komprehensif, sekaligus
                memastikan bahwa pada akhirnya Anda memiliki kontrol atas informasi pribadi apa pun yang diberikan kepada kami.
                Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, mengungkapkan, memproses, dan
                menyimpan
                informasi apa pun yang Anda berikan kepada kami saat Anda menggunakan Aplikasi kami. Kami akan secara ketat
                mematuhi
                Kebijakan Privasi ini untuk menggunakan informasi tersebut.</p>
            <p>Kebijakan Privasi ini akan menjelaskan hal-hal berikut:</p>
            <p>1. Informasi apa yang kami kumpulkan dan cara kami menggunakannya</p>
            <p>2. Cara kami menggunakan Cookie dan teknologi serupa</p>
            <p>3. Cara kami mempercayakan pihak lain untuk memproses, membagikan, mentransfer, dan mengungkap informasi pribadi
                Anda untuk publik</p>
            <p>4. Cara kami menyimpan dan melindungi informasi pribadi Anda</p>
            <p>5. Hak Anda</p>
            <p>6. Transfer data antar negara</p>
            <p>7. Hubungi kami</p>
            <p>8. Cara kami memperbarui Kebijakan Privasi ini</p>
            <p>Lampiran I: Detail SDK pihak ketiga</p>
            <p>Tujuan kami adalah memberikan pengalaman pengguna yang terbaik untuk Anda. Kami telah menyiapkan departemen dan
                petugas khusus untuk penanganan masalah privasi, apabila Anda memiliki pertanyaan apa pun tentang Kebijakan
                Privasi
                ini, Anda dapat menghubunginya melalui informasi kontak pada bagian VII dalam Kebijakan Privasi ini. Kami akan
                memberikan jawaban sesuai dengan waktu yang ditentukan oleh kebijakan dan hukum negara masing-masing. Jika Anda
                tidak merasa puas atas jawaban dari kami, terutama ketika Anda yakin bahwa pemrosesan informasi pribadi oleh
                kami
                telah merugikan hak dan kepentingan sah Anda, Anda juga dapat menyelesaikannya melalui saluran eksternal seperti
                mengajukan guagatan ke pengadilan yang memiliki yurisdiksi, mengajukan keluhan ke badan pengawasan pemerintah,
                dll.
            </p>
            <p><strong>I. Informasi apa yang kami kumpulkan dan cara kami menggunakannya</strong></p>
            <p>Informasi pribadi mengacu pada berbagai data yang direkam secara elektronik atau dengan cara lain yang dapat
                mengidentifikasi individu tertentu melalui informasi itu sendiri atau melalui asosiasi dengan informasi lain.
            </p>
            <p>Informasi pribadi yang sensitif merupakan informasi pribadi yang potensial membahayakan keselamatan pribadi dan
                keamanan harta benda, berdampak negatif pada reputasi pribadi, kesehatan fisik dan mental, atau rawan terhadap
                praktik diskriminasi jika informasi tersebut bocor, diberikan secara ilegal atau disalahgunakan, termasuk namun
                tidak terbatas pada nomor KTP, data pribadi biometrik, nomor rekening bank, informasi kekayaan, informasi
                keberadaan, informasi transaksi, informasi pribadi anak di bawah umur 14 tahun (inklusif), dll.</p>
            <p>Tujuan utama kami mengumpulkan informasi pribadi adalah untuk menyediakan produk dan/atau layanan kepada Anda,
                dan
                kami menjanji bahwa kami mematuhi undang-undang, peraturan, dan dokumen normatif lainnya yang berlaku. Anda
                berhak
                memilih untuk memberikan atau tidak memberikan informasi yang diminta, tetapi dalam sebagian besar kasus,
                apabila
                Anda tidak memberikannya, kami mungkin tidak dapat menyediakan layanan yang sesuai atau menanggapi pertanyaan
                Anda.
            </p>
            <p><strong>1.1 Situasi pengumpulan dan pemrosesan informasi pribadi Anda dalam layanan dasar Dreamehome</strong></p>
            <p><strong>1.1.1 Aplikasi Dreamehome menghubungkan dan mengelola perangkat pintar</strong></p>
            <p>Untuk memberi Anda layanan Dreamehome dan memungkinkan Anda untuk menghubungkan dan mengelola perangkat pintar
                dengan aman, kami dapat mengumpulkan informasi Anda termasuk informasi Wi-Fi, lokasi, ID akun, ponsel, perangkat
                pintar, dan informasi penautan antara akun Dreame dan perangkat pintar. Informasi ini akan digunakan untuk
                memberi
                Anda berbagai fitur seperti koneksi cepat, penautan, penemuan perangkat di sekitar, dan pengelolaan perangkat.
                Informasi di atas dijelaskan secara rinci sebagai berikut:</p>
            <p>Informasi terkait ID akun: nama pengguna, kata sandi, nama panggilan, avatar, email, nomor ponsel untuk akun
                Dreame
                Anda. Diantaranya, <strong>nama pengguna, kata sandi, nomor ponsel, dan email adalah informasi pribadi yang
                    sensitif.</strong> Tujuan pengumpulan informasi tersebut adalah untuk memverifikasi identitas pengguna dan
                mendapatkan izin mengakses server bagi akun Dreame. Nama pengguna dan kata sandi yang Anda masukkan akan
                dienkripsi
                dan dikirimkan ke server akun Dreame untuk diotentikasi.</p>
            <p>Informasi terkait ponsel: pengidentifikasi perangkat keras (IMEI/OAID, alamat Mac, ID Android), model ponsel,
                informasi versi sistem, bahasa sistem, pengaturan negara atau wilayah ponsel, ukuran dan resolusi layar ponsel,
                informasi CPU dan perangkat tampilan. Tujuan pengumpulan informasi tersebut adalah untuk memungkinkan aplikasi
                Dreamehome terhubung ke perangkat pintar.</p>
            <p>Informasi terkait perangkat pintar: nama, model, versi, produsen, pengidentifikasi perangkat, alamat MAC, alamat
                IP, status pengoperasian perangkat, atribut khusus, parameter pengaturan, peristiwa bisnis, pengelolaan
                perangkat
                dan catatan penggunaan perangkat pintar. Tujuan pengumpulan informasi tersebut adalah untuk menautkan perangkat
                pintar agar mengontrol dan mengelola perangkat, mengatur atribut dan parameter perangkat, serta memeriksa status
                kerja dan catatan sejarah perangkat.</p>
            <p><strong>1.1.2 Peningkatan aplikasi Dreamehome dan perangkat pintar</strong></p>
            <p>Agar Anda dapat terus menikmati layanan Dreamehome terbaru, kami mungkin menggunakan informasi versi aplikasi
                Dreamehome dan model ponsel Anda untuk memberi Anda layanan peningkatan aplikasi Dreamehome. Pada saat yang
                sama,
                kami mungkin mengumpulkan informasi perangkat pintar apa saja yang Anda hubungkan serta nomor versinya untuk
                memberi
                Anda layanan peningkatan perangkat pintar supaya memastikan bahwa Anda dapat menggunakan layanan versi terbaru
                (termasuk versi firmware). </p>
            <p>Dreamehome hanya menyediakan jalur peningkatan untuk perangkat pintar, versi firmware perangkat pintar disediakan
                oleh produsen perangkat pintar, dan produsen tersebut bertanggung jawab atas kualitas versi dan hasil
                peningkatan.
            </p>
            <p>Jika Anda tidak memberikan informasi semacam ini, Anda tidak dapat meningkatkan versi aplikasi Dreamehome dan
                firmware perangkat pintar.</p>
            <p><strong>1.1.3 Mendapatkan umpan balik pengguna secara online</strong></p>
            <p>Untuk membantu Anda memecahkan masalah yang mungkin muncul pada aplikasi Dreamehome atau perangkat pintar secara
                lebih efektif, kami menyediakan saluran untuk umpan balik pengguna secara online. Dalam hal ini, kami perlu
                mengumpulkan informasi berikut dari Anda : informasi log aplikasi Dreamehome dan perangkat, informasi kontak dan
                deskripsi permasalahan Anda, gambar dan video mengenai masalah tersebut. Informasi log aplikasi dan perangkat
                itu
                mencakup status perangkat, informasi yang dikumpulkan oleh perangkat sensor, catatan operasi perangkat,
                pengidentifikasi perangkat, dll. Tujuan pengumpulan informasi tersebut adalah untuk menemukan dan menganalisis
                penyebab masalah; tujuan mengumpulkan informasi kontak Anda adalah untuk berkorespondensi dengan Anda supaya
                kami
                mengetahui apakah masalah telah teratasi sepenuhnya, atau untuk menghubungi Anda untuk menambahkan informasi
                lain
                yang diperlukan.</p>
            <p>Kami akan menggunakan informasi pribadi Anda dengan ketentuan berikut: hanya digunakan untuk penentuan penyebab
                dan
                penyelesaian masalah yang dilaporkan, tidak digunakan untuk penampilan atau periklanan komersial. Jika Anda
                tidak
                memberikan informasi semacam ini, kami tidak dapat dengan efektif menemukan penyebab dan memecahkan masalah yang
                Anda laporkan.</p>
            <p><strong>1.2 Situasi pengumpulan dan pemrosesan informasi pribadi Anda di luar layanan dasar Dreamehome</strong>
            </p>
            <p>Selain layanan dasar Dreamehome dapat menggunakan informasi pribadi Anda, fitur tambahan kami berikut ini juga
                dapat mengumpulkan dan menggunakan informasi pribadi Anda. Jika Anda tidak memberikan informasi pribadi ini,
                Anda
                tetap dapat menggunakan layanan dasar Dreamehome, tetapi Anda mungkin tidak dapat menggunakan fitur tambahan
                yang
                dapat memberikan kenyamanan bagi Anda. Fitur tambahan tersebut meliputi:</p>
            <p><strong>Program peningkatan pengalaman pengguna</strong></p>
            <p>Untuk meningkatkan pengalaman pengguna, kami perlu mengumpulkan informasi berikut dari Anda : Log Dreamehome yang
                berisi log proses kunci, log peristiwa, log kesalahan, peristiwa bisnis, penggunaan antarmuka para aplikasi yang
                telah dienkripsi, dll., log tersebut tidak akan mencatat informasi sensitif Anda.</p>
            <p>Kami akan menggunakan informasi pribadi Anda dengan ketentuan berikut: mengumpulkan informasi di atas secara
                otomatis dan mengunggahnya ke server, menganalisis informasi log untuk menentukan kondisi operasi perangkat dan
                menganalisis penggunaan aplikasi.</p>
            <p>Jika Anda tidak memberikan informasi ini, Dreamehome tidak dapat meningkatkan pengalaman Anda secara tepat waktu,
                tetapi hal ini tidak akan memengaruhi penggunaan fitur dasar layanan ini.</p>
            <p> <strong>1.3 Informasi dari sumber pihak ketiga</strong></p>
            <p>Apabila diizinkan menurut hukum, kami akan mengumpulkan informasi Anda dari sumber pihak ketiga. Misalnya,</p>
            <p>1.3.1 Dengan otorisasi Anda, kami akan bekerja sama dengan penyedia layanan pihak ketiga dalam pengelolaan
                perangkat pintar pihak ketiga, pengelolaan tersebut mungkin melibatkan perolehan informasi pribadi Anda oleh
                kami
                dari penyedia layanan pihak ketiga. Dalam pengelolaan perangkat pihak ketiga, kami akan memperoleh informasi
                pribadi
                berikut ini dari Anda dengan syarat Anda telah menautkan akun pihak ketiga:</p>
            <p>Informasi akun pihak ketiga, termasuk nama panggilan dan avatar Anda, digunakan untuk ditampilkan di aplikasi
                Dreamehome;</p>
            <p>Informasi perangkat dan jaringan, termasuk pengidentifikasi perangkat, alamat MAC, dan nomor seri perangkat,
                digunakan untuk mengidentifikasi perangkat yang saat ini berfungsi dan mengontrol keamanan perangkat.</p>
            <p>Jika pemrosesan informasi pribadi yang perlu kami lakukan saat menjalankan bisnis berada di luar cakupan
                otorisasi
                dan persetujuan Anda yang diberikan kepada penyedia layanan pihak ketiga, kami akan memperoleh persetujuan
                eksplisit
                Anda sebelum memproses informasi pribadi Anda. Selain itu, kami juga akan secara ketat mematuhi peraturan
                perundang-undangan yang terkait, dan mewajibkan penyedia layanan pihak ketiga untuk memastikan legalitas
                informasi
                yang mereka berikan.</p>
            <p><strong>1.4 Informasi non-pribadi</strong></p>
            <p>Kami juga dapat mengumpulkan informasi lain yang tidak dengan sendirinya mengidentifikasi perorangan secara
                spesifik (yaitu Informasi yang Tidak Dapat Diidentifikasi Secara Pribadi). Informasi tersebut dapat meliputi
                data
                statistik yang dihasilkan ketika Anda menggunakan layanan tertentu (misalnya, perilaku pengguna termasuk
                mengklik,
                mengakses halaman, waktu yang dihabiskan untuk laman). Tujuan pengumpulan tersebut adalah untuk meningkatkan
                layanan
                yang kami sediakan untuk Anda. Jenis dan jumlah informasi yang dikumpulkan akan bergantung pada cara Anda
                menggunakan layanan kami. Kami akan mengumpulkan informasi tersebut untuk membantu kami lebih memahami perilaku
                pengguna, memberi tahu kami bagian mana dari situs web, produk, dan layanan kami yang paling diminati sehingga
                kami
                dapat mengoptimalkan antarmuka layanan kami dan menyediakan informasi yang lebih berguna kepada pelanggan. Dalam
                Kebijakan Privasi ini, kami memperlakukan informasi yang dikumpulkan ini sebagai informasi non-pribadi. Apabila
                kami
                menggabungkan Informasi yang Tidak dapat Diidentifikasi Secara Pribadi dengan Informasi Pribadi, informasi
                gabungan
                tersebut akan diperlakukan sebagai informasi pribadi selama tetap digabungkan.</p>
            <p><strong>II. Cara kami menggunakan cookie dan teknologi serupa</strong></p>
            <p>Untuk memastikan pengoperasian Dreamehome secara normal, kami akan menyimpan file data kecil bernama Cookie di
                perangkat Anda. Cookie biasanya berisi pengenal, nama situs, dan beberapa angka dan karakter. Dengan adanya
                Cookie,
                Dreamehome dapat menyimpan akun login, preferensi Anda, dan data lainnya. </p>
            <p>Kami tidak akan menggunakan Cookie untuk tujuan apa pun selain yang disebutkan dalam pernyataan ini. Anda dapat
                mengelola atau menghapus Cookie sesuai dengan preferensi Anda. Jika begitu, dalam beberapa kasus, hal ini dapat
                memengaruhi akses aman Anda ke Dreamehome, dan Anda mungkin perlu mengubah pengaturan pengguna setiap kali Anda
                mengakses Dreamehome.</p>
            <p><strong>III. Cara kami mempercayakan pihak lain untuk memproses, membagikan, mentransfer, dan mengungkap
                informasi
                pribadi Anda untuk publik</strong></p>
            <p><strong>3.1 Mempercayakan pihak lain untuk memproses</strong></p>
            <p>Dalam keadaan umum, Dreame dapat mempercayakan perusahaan lain untuk memproses informasi pribadi Anda atas nama
                kami. Misalnya, perusahaan yang menghubungi Anda, mengirim email, atau memberi Anda dukungan teknis atas nama
                kami,
                perusahaan ini semata-mata hanya dapat menggunakan informasi pribadi Anda untuk menyediakan layanan kepada Anda
                atas
                nama kami.</p>
            <p>Kami akan menandatangani perjanjian kerahasiaan atau klausul pemrosesan informasi pribadi yang ketat dengan pihak
                yang dipercayakan untuk mengharuskannya untuk menerapkan sejumlah langkah kerahasiaan dan keamanan yang relevan
                dan
                menangani informasi pribadi sesuai dengan Kebijakan Privasi ini.</p>
            <p><strong>3.2 Membagikan</strong></p>
            <p>Dalam keadaan umum, kami tidak akan membagikan informasi pribadi Anda dengan entitas eksternal, kecuali dalam
                kasus
                berikut:</p>
            <p>3.2.1 Dengan persetujuan eksplisit Anda, kami dapat membagikan informasi dalam lingkup otorisasi Anda kepada
                pihak
                ketiga yang ditunjuk oleh Anda. Dan atas permintaan Anda, kami dapat membagikan informasi dan konfigurasi
                peranti
                rumah pintar Anda dengan kerabat dan teman Anda supaya mereka dapat dengan cepat menggunakan perangkat lunak dan
                layanan ini melalui perangkat terminalnya.</p>
            <p>3.2.2 Beberapa layanan antara layanan Dreamehome seperti web hosting, analisis data, pembayaran dan pemrosesan
                kartu kredit, penyediaan infrastruktur, layanan IT, layanan dukungan pelanggan, layanan pengiriman email, dan
                layanan serupa lainnya disediakan oleh penyedia layanan pihak ketiga, oleh karena itu kami perlu memberikan
                sebagian
                informasi pribadi Anda kepada penyedia layanan pihak ketiga untuk memastikan bahwa mereka dapat memberikan
                layanan
                kepada kami.</p>
            <p>3.2.3 Mengungkapkan informasi pribadi Anda kepada pelanggan dan mitra bisnis lainnya yang secara langsung atau
                tidak langsung memberi Anda perangkat pintar dan/atau jaringan dan sistem yang Anda gunakan untuk mengakses dan
                menggunakan situs web dan layanan kami.</p>
            <p>3.2.4 Mengungkapkan informasi pribadi Anda kepada perusahaan afiliasi atau pihak ketiga lainnya ketika Dreame
                terlibat dalam reorganisasi, merger, penjualan, joint venture, transfer, pengalihan atau pelepasan lain dari
                semua
                atau sebagian bisnis, aset atau saham kami (termasuk namun tidak terbatas pada situasi di atas terkait dengan
                kebangkrutan atau prosedur serupa). Dalam hal ini, kami akan memberi tahu Anda perihal perubahan kepemilikan,
                ketidakkompatibelan penggunaan informasi pribadi, dan pilihan informasi pribadi apa pun yang mungkin Anda miliki
                melalui email dan/atau dengan memposting pemberitahuan dengan jelas di situs web kami.</p>
            <p>3.2.5 Dalam situasi yang kami anggap perlu atau patut dibagikan: (a) untuk mematuhi hukum dan peraturan yang
                berlaku; (b) untuk mematuhi prosedur hukum; (c) untuk menanggapi permintaan dari lembaga publik dan lembaga
                pemerintah, termasuk permintaan dari lembaga publik dan lembaga pemerintah di luar negara/wilayah tempat Anda
                tinggal; (d) memenuhi syarat dan ketentuan kami; (e) melindungi operasi, bisnis, dan sistem kami; (f) melindungi
                hak, privasi, keamanan, atau kekayaan kami dan/atau pengguna lain, termasuk Anda; dan (g) mencari dan mengambil
                tindakan perbaikan atau membatasi kerugian yang mungkin diderita oleh kami.</p>
            <p>3.2.6 Mengungkapkan informasi pribadi Anda kepada anak perusahaan atau afiliasi perusahaan untuk melakukan
                kegiatan
                bisnis secara berkala</p>
            <p>3.2.7 Kami akan membagikan data yang diperlukan dengan pihak ketiga melalui antarmuka pemrograman aplikasi
                (application programming interface disingkat API) dan kit pengembangan perangkat lunak (software development kit
                disingkat SDK). Pihak ketiga yang jenis berbeda memiliki SDK yang berbeda, pada umumnya meliputi login, berbagi,
                pembayaran, pemberitahuan push, statistik, dll., Kami akan melakukan pemeriksaan keamanan yang ketat terhadap
                pihak
                ketiga dan menyepakati dan menerapkan langkah-langkah perlindungan data. Lampiran I adalah detail SDK pihak
                ketiga
                yang kami izinkan untuk diakses, harap baca dengan seksama. Kebijakan privasi kami tidak berlaku untuk produk
                atau
                layanan yang disediakan oleh pihak ketiga. Saat Anda menggunakan produk atau layanan tersebut, informasi Anda
                mungkin juga dikumpulkan oleh mereka. Maka kami sangat menyarankan Anda meluangkan waktu untuk membaca kebijakan
                privasi pihak ketiga, seperti halnya membaca kebijakan kami. Kami tidak bertanggung jawab atas penggunaan
                informasi
                pribadi Anda oleh pihak ketiga, kami juga tidak dapat mengontrol penggunaannya. Kebijakan privasi kami tidak
                berlaku
                untuk situs web lain yang terhubung melalui layanan kami. Anda perlu secara independen menilai interaksi Anda
                dengan
                situs web yang ditautkan. Sebelum Anda memasuki halaman pihak ketiga untuk pertama kalinya, penyedia layanan
                pihak
                ketiga akan menunjukkan kepada Anda kebijakan privasi dan perjanjian yang relevan, harap baca dengan seksama.
            </p>
            <p><strong>3.3 Transfer</strong></p>
            <p>Dreame tidak akan mentransfer informasi pribadi Anda ke perusahaan, organisasi, atau individu mana pun kecuali
                dalam kasus berikut:</p>
            <p>3.3.1 Kami akan mentransfer informasi pribadi Anda ke pihak lain apabila kami telah mendapatkan persetujuan
                secara
                eksplisit dari Anda;</p>
            <p>3.3.2 Jika Dreame terlibat dalam merger, akuisisi, atau likuidasi kebangkrutan sehingga perlu mentrasfer
                informasi
                pribadi Anda kepada perusahaan atau organisasi lain, kami akan meminta perusahaan atau organisasi tersebut untuk
                terus terikat dengan Kebijakan Privasi ini. Jika tidak, kami akan mewajibkannya untuk sekali lagi meminta
                persetujuan kepada Anda.</p>
            <p><strong>3.4 Pengungkapan ke publik</strong></p>
            <p>Kami hanya akan mengungkap informasi pribadi Anda ke publik dalam situasi berikut:</p>
            <p>3.4.1 Apabila kami telah mendapatkan persetujuan secara eksplisit dari Anda;</p>
            <p>3.4.2 Pengungkapan ke publik berdasarkan hukum: termasuk hukum dan peraturan, prosedur hukum, litigasi, atau atas
                permintaan dari departemen pemerintah yang kompeten.</p>
            <p><strong>IV. Cara kami menyimpan dan melindungi informasi pribadi Anda</strong></p>
            <p>Kami menyimpan informasi pribadi selama periode yang diperlukan untuk tujuan pengumpulan informasi sebagaimana
                yang
                dijelaskan dalam Kebijakan Privasi ini, atau sebagaimana yang diwajibkan menurut undang-undang yang berlaku.
                Kami
                akan berhenti menyimpan dan menghapus serta menganonimkan informasi pribadi setelah tujuan pengumpulan
                terpenuhi,
                atau setelah kami mengonfirmasi permintaan penghapusan atau pembatalan Anda, atau setelah kami menghentikan
                operasi
                produk atau layanan yang sesuai. Pengecualian atas hal ini adalah informasi pribadi yang kami proses untuk
                kepentingan publik, sains, riset historis, atau tujuan statistik. Kami akan terus menyimpan data yang relevan
                berdasarkan hukum yang berlaku, meskipun pemrosesan data lebih lanjut tidak terkait dengan tujuan pengumpulan
                yang
                semula.</p>
            <p>Dalam bisnis Dreamehome, jangka waktu penyimpanan data pribadi Anda secara mendetail adalah sebagai berikut:</p>
            <p>Untuk data yang tersimpan secara lokal di aplikasi Dreamehome, semua data yang tersimpan akan langsung dihapus
                saat
                Anda meng-uninstall aplikasi Dreamehome atau menghapus data aplikasi Dreamehome.</p>
            <p>Untuk data perangkat pintar dan bisnis Dreamehome yang tersimpan di server, semua data yang tersimpan akan
                langsung
                dihapus saat Anda menghapus perangkat pintar, menolak menyetujui kebijakan privasi Dreamehome dan berhenti
                menggunakan layanan Dreamehome.</p>
            <p>Untuk log bisnis, data statistik, dan catatan historis yang tersimpan di server, kami akan menghapusnya saat kami
                menghapus data server dari waktu ke waktu, dan jangka waktu penyimpanan data tersebut biasanya tidak lebih dari
                2
                tahun.</p>
            <p>Selain itu, ketika produk atau layanan kami berhenti beroperasi, kami akan memberi tahu Anda dalam bentuk
                pemberitahuan push, pengumuman, dll., dan menghapus atau menganonimkan informasi pribadi Anda dalam jangka waktu
                yang wajar.</p>
            <p><strong>V. Hak Anda</strong></p>
            <p><strong>5.1 Mengakses, meralat, dan menghapus informasi pribadi Anda</strong></p>
            <p>Tergantung pada hukum dan peraturan di wilayah atau negara Anda yang berlaku, Anda berhak mengakses, meralat, dan
                menghapus informasi pribadi apa pun yang kami simpan tentang Anda (untuk selanjutnya disebut sebagai
                “permintaan”).
                Silakan menghubungi kami dengan mengirim email atau mengunjungi situs Dreamehome. Kebanyakan undang-undang
                mengharuskan permintaan subjek informasi pribadi untuk mematuhi persyaratan tertentu. Kebijakan Privasi ini
                mewajibkan permintaan Anda mematuhi situasi berikut ini:</p>
            <p>Melalui saluran permintaan eksklusif kami dan untuk melindungi keamanan informasi Anda, permintaan Anda harus
                dibuat secara tertulis (kecuali apabila hukum setempat secara eksplisit mengakui permintaan lisan);</p>
            <p>Memberikan informasi yang cukup agar kami dapat memverifikasi identitas Anda dan memastikan bahwa Anda adalah
                subjek data atau orang yang secara hukum diberi wewenang untuk bertindak atas nama subjek data tersebut;</p>
            <p>Setelah kami memperoleh informasi yang cukup untuk mengonfirmasi bahwa permintaan Anda dapat diproses, kami akan
                melanjutkan untuk menanggapi permintaan Anda dalam jangka waktu yang telah ditetapkan berdasarkan undang-undang
                perlindungan data yang berlaku untuk Anda. Secara detail:</p>
            <p>Berdasarkan permintaan Anda dan persyaratan hukum yang berlaku, salinan data pribadi Anda yang dikumpulkan dan
                diproses oleh kami akan diberikan kepada Anda secara gratis. Untuk permintaan tambahan atas informasi yang
                relevan,
                kami dapat membebankan biaya yang wajar berdasarkan biaya administratif aktual sesuai dengan hukum yang berlaku.
            </p>
            <p>Jika ada informasi yang kami miliki mengenai Anda yang salah atau tidak lengkap, Anda berhak meminta informasi
                pribadi Anda dikoreksi atau dilengkapi berdasarkan tujuan penggunaan.</p>
            <p>Berdasarkan persyaratan hukum yang berlaku, Anda berhak untuk meminta penghapusan informasi pribadi Anda. Kami
                akan
                mempertimbangkan permintaan penghapusan Anda dan mengambil langkah-langkah yang wajar termasuk tindakan teknis
                apabila permintaan Anda memenuhui persyaratan. Setelah Anda atau kami membantu Anda menghapus informasi terkait,
                kami mungkin tidak dapat segera menghapus informasi dari sistem pencadangan sehubungan dengan hukum yang berlaku
                dan/atau batasan teknis. Jika ini masalahnya, kami akan menyimpan informasi pribadi Anda dengan aman dan
                memisahkannya dari pemrosesan lebih lanjut hingga cadangan tersebut dapat dihapus atau dianonimkan. Misalnya,
                informasi produk dan layanan serta informasi transaksi Anda akan disimpan setidaknya selama tiga tahun sejak
                tanggal
                penyelesaian transaksi menurut Hukum E-Commerce Republik Rakyat Tiongkok (E-commerce Law of the People’s
                Republic of
                China).</p>
            <p>Kami berhak menolak untuk memproses permintaan yang bersifat remeh-temeh, permintaan yang merusak hak privasi
                orang
                lain, permintaan yang sangat tidak realistis, permintaan yang memerlukan pekerjaan teknis yang tidak
                proporsional,
                dan permintaan yang tidak diwajibkan menurut hukum setempat, informasi yang telah dipublikasikan, informasi yang
                diberikan dalam kondisi rahasia. Permintaan juga dapat ditolak jika kami percaya bahwa aspek tertentu dari
                permintaan untuk menghapus atau mengakses data dapat mengakibatkan ketidakmampuan kami untuk menggunakan
                informasi
                secara sah untuk tujuan anti-penipuan dan keamanan yang disebutkan di atas.</p>
            <p><strong>5.2 Penarikan persetujuan</strong></p>
            <p>Anda dapat menarik persetujuan yang sebelumnya diberikan kepada kami untuk tujuan tertentu dengan mengajukan
                permintaan, termasuk pengumpulan, penggunaan, dan/atau pengungkapan informasi pribadi Anda yang kami miliki atau
                kontrol. Sesuai dengan layanan spesifik yang Anda gunakan, Anda dapat menghubungi kami untuk operasi terkait
                melalui
                informasi kontak pada bagian VII dalam Kebijakan Privasi ini. Kami akan memproses permintaan Anda dalam waktu
                yang
                wajar sejak saat permintaan diajukan, dan setelah itu tidak akan mengumpulkan, menggunakan, dan/atau mengungkap
                informasi pribadi Anda sesuai permintaan Anda. </p>
            <p>Bergantung pada sejauh mana penarikan izin Anda, harap perhatikan bahwa Anda mungkin tidak dapat terus menerima
                manfaat penuh dari produk dan layanan Dreamehome. Penarikan persetujuan atau otorisasi Anda tidak akan
                memengaruhi
                validitas pemrosesan kami yang dilakukan berdasarkan izin hingga pada waktu penarikan.</p>
            <p>Anda dapat menarik persetujuan Anda atas penggunaan informasi pribadi ini dengan meminta penarikan persetujuan
                atau
                memasuki situs Dreamehome untuk membuat perubahan untuk keluar dari program peningkatan pengalaman pengguna.</p>
            <p><strong>5.3 Membatalkan akun Dreamehome</strong></p>
            <p>Anda dapat membatalkan akun Dreamehome dengan mengklik “Saya”-“Pengaturan Akun”-“Membatalkan Akun”. Jika Anda
                ingin
                membatalkan akun Dreamehome, perhatikan bahwa pembatalan tersebut akan mencegah Anda menggunakan fungsionalitas
                lengkap dari produk dan layanan Dreamehome. Untuk melindungi hak dan kepentingan sah Anda atau orang lain, kami
                akan
                menentukan apakah mendukung permintaan pembatalan Anda berdasarkan penggunaan produk dan layanan Dreamehome oleh
                Anda.</p>
            <p><strong>VI. Transfer Data Antar Negara</strong></p>
            <p>Kami menyediakan produk atau layanan dengan menggunakan sumber daya dan server yang berada di seluruh dunia, oleh
                karena itu, setelah mendapatkan otorisasi dan persetujuan Anda, informasi pribadi Anda mungkin ditransfer kepada
                atau diakses oleh entitas yang di luar negara/wilayah tempat Anda menggunakan produk atau layanan. Langkah
                keamanan
                perlindungan data dan undang-undang lain di negara/wilayah tempat informasi Anda ditransfer mungkin tidak
                selengkap
                dengan yang berlaku di negara/wilayah Anda. Dalam kasus seperti itu, kami akan mengambil langkah yang sesuai dan
                legal berdasarkan hukum yang berlaku di setiap yurisdiksi untuk memastikan informasi pribadi Anda terus
                dilindungi.
            </p>
            <p>Secara khusus:</p>
            <p>Jika Anda adalah penduduk Wilayah Ekonomi Eropa (European Economic Area/EEA) dan informasi pribadi Anda
                ditransfer
                ke luar EEA, kami akan memproses informasi pribadi Anda di area yang telah ditetapkan oleh Komisi Eropa sebagai
                area
                yang dapat memberikan perlindungan yang memadai; atau mengambil tindakan perlindungan yang sesuai untuk
                melindungi
                informasi pribadi Anda, termasuk mentransfer informasi sesuai dengan mekanisme transmisi yang berlaku, seperti
                klausul kontrak standar Komisi Eropa .</p>
            <p><strong>VII. Hubungi Kami</strong></p>
            <p>Jika Anda memiliki komentar atau pertanyaan tentang Kebijakan Privasi ini atau pertanyaan apa pun yang berkaitan
                dengan pengumpulan, penggunaan, atau pengungkapan informasi pribadi Anda oleh kami, silakan menghubungi kami di
                alamat di bawah ini dengan mengacu pada “Kebijakan Privasi”, atau mengklik “Saya” dan “Ikuti dan Umpan Balik”.
                Untuk
                menanggapi permintaan hak, pertanyaan, konsultasi tentang informasi pribadi Anda, kami memiliki tim profesional
                yang
                akan menyelesaikan masalah Anda. Jika pertanyaan Anda itu sendiri melibatkan masalah yang signifikan, kami
                mungkin
                akan meminta informasi lebih lanjut. Jika Anda tidak merasa puas dengan tanggapan yang diterima, Anda dapat
                mengalihkan keluhan kepada otoritas pengawas yang relevan di yurisdiksi Anda. Jika Anda berkonsultasi dengan
                kami,
                kami akan memberikan informasi tentang saluran pengaduan yang relevan yang dapat berlaku berdasarkan situasi
                Anda
                yang sebenarnya.</p>
            <p><strong>Alamat E-mail:</strong></p>
            <ul>
                <li>Informasi kontak untuk wilayah Tiongkok: <a className="page"
                    href="mailto:privacy@dreame.tech">privacy@dreame.tech</a></li>
                <li>Informasi kontak DPO Singapura: <a className="page"
                    href="mailto:dpo.sg@dreame.tech">dpo.sg@dreame.tech</a></li>
                <li>Informasi kontak Perwakilan UE: <a className="page"
                    href="mailto:representative.dreame@herrero.es">representative.dreame@herrero.es</a></li>
            </ul>
            <p><strong>Nomor telepon:</strong> 400-875-9511</p>
            <p><strong>Situs Web: </strong><a className="page"
                href="https://www.dreametech.com/ ">https://www.dreametech.com/ </a></p>
            <p><strong>VIII. Cara kami memperbarui Kebijakan Privasi ini</strong></p>
            <p>Dreame berhak untuk memperbarui kebijakan ini secara tepat waktu. Ketika kebijakan berubah, kami akan menunjukkan
                kepada Anda kebijakan yang telah diubah melalui jendela pop-up atau cara signifikan lainnya. Hanya setelah
                mendapatkan persetujuan Anda, kami akan mengumpulkan, menggunakan, dan menyimpan informasi pribadi Anda sesuai
                dengan kebijakan yang diperbarui.</p>
            <p>Kebijakan ini mulai berlaku sejak tanggal pembaruan.</p>
            <p>Terakhir diperbarui pada 28 Agustus 2021</p>
            <p><strong>Lampiran I:</strong> <strong>Detail SDK pihak ketiga</strong></p>
            <p>* Untuk memberi Anda layanan dasar dan fitur tambahan yang lebih profesional dan aman, Dreamehome akan mengakses
                produk SDK pihak ketiga. Produk SDK pihak ketiga yang saat ini ada di Dreamehome diungkapkan sebagai berikut:
            </p>
            <div className='tableStyle'>
                <table>
                    <tr>
                        <td>
                            <p><strong>Layanan SDK</strong></p>
                        </td>
                        <td>
                            <p><strong>Fungsi spesifik</strong></p>
                        </td>
                        <td>
                            <p><strong>Informasi yang diperoleh</strong></p>
                        </td>
                        <td>
                            <p><strong>Kebijakan privasi pihak ketiga</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>SDK Statistik dan Analisis Umeng</p>
                        </td>
                        <td>
                            <p>Statistik dan Analisis</p>
                        </td>
                        <td>
                            <p>Pengidentifikasi perangkat (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, Informasi IMSI kartu SIM), lokasi
                                geografis</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>SDK Pemberitahuan Push Umeng</p>
                        </td>
                        <td>
                            <p>Pemberitahuan push</p>
                        </td>
                        <td>
                            <p>Pengidentifikasi perangkat (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, Informasi IMSI kartu SIM), lokasi
                                geografis</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>SDK berbagi sosial</p>
                        </td>
                        <td>
                            <p>Berbagi pihak ketiga</p>
                        </td>
                        <td>
                            <p>Pengidentifikasi perangkat (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, Informasi IMSI kartu SIM), lokasi
                                geografis</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>SDK Agora</p>
                        </td>
                        <td>
                            <p>Hubungkan mikrofon, siaran streaming video</p>
                        </td>
                        <td>
                            <p>Informasi perangkat, status jaringan, kamera, mikrofon, ruang memori baca/tulis</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.agora.io/cn/privacy-policy/">https://www.agora.io/cn/privacy-policy/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>SDK Push Huawei</p>
                        </td>
                        <td>
                            <p>Push</p>
                        </td>
                        <td>
                            <p>Informasi identifikasi perangkat</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169">https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>SDK Push Xiaomi</p>
                        </td>
                        <td>
                            <p>Push</p>
                        </td>
                        <td>
                            <p>Informasi identifikasi perangkat, model perangkat, jenis jaringan, penyimpanan perangkat, informasi
                                proses
                                operasi perangkat, versi aplikasi, versi SDK</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>SDK Push OPPO</p>
                        </td>
                        <td>
                            <p>Push</p>
                        </td>
                        <td>
                            <p>Informasi identifikasi perangkat</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.oppomobile.com/wiki/doc#id=10194">https://open.oppomobile.com/wiki/doc#id=10194</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>SDK Push VIVO</p>
                        </td>
                        <td>
                            <p>Push</p>
                        </td>
                        <td>
                            <p>Informasi identifikasi perangkat</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>SDK Wechat</p>
                        </td>
                        <td>
                            <p>Login melalui Wechat, berbagi di Wechat</p>
                        </td>
                        <td>
                            <p>Informasi identifikasi perangkat, informasi jaringan</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>SDK QQ</p>
                        </td>
                        <td>
                            <p>Berbagi</p>
                        </td>
                        <td>
                            <p>Informasi identifikasi perangkat, informasi jaringan</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>SDK Sina-Weibo</p>
                        </td>
                        <td>
                            <p>Login melalui Sina-Weibo, berbagi di Sina-Weibo</p>
                        </td>
                        <td>
                            <p>Informasi identifikasi perangkat, informasi jaringan</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>SDK AppleID</p>
                        </td>
                        <td>
                            <p>Login dengan Apple ID</p>
                        </td>
                        <td>
                            <p>Apple ID</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.Apple.com/legal/privacy/szh/">https://www.Apple.com/legal/privacy/szh/</a></p>
                        </td>
                    </tr>
                </table>
            </div>
            <div className='height'></div>

        </div>
    )
}

export default PricacyPolicy